import { useEffect, useState } from "react";
import { Wrench, MapPin, Calendar, Clock } from "lucide-react";
import api from "@/lib/api";
import { formatFCFA, formatDate } from "@/lib/format";
import { Loader, EmptyState, StatusBadge } from "@/components/common";
import { INSTALL_STATUS, INSTALL_STEPS } from "@/lib/labels";

export default function InstallationsPage() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/installations").then((r) => setItems(r.data)); }, []);
  if (!items) return <Loader />;

  if (items.length === 0)
    return <EmptyState icon={Wrench} title="Aucune installation" subtitle="Vos demandes d'installation apparaîtront ici." />;

  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold text-[#0F172A] mb-5">Mes installations</h1>
      <div className="space-y-4">
        {items.map((ins) => {
          const step = INSTALL_STEPS.indexOf(ins.status);
          return (
            <div key={ins.id} className="bg-white border border-slate-200 rounded-xl p-4" data-testid={`install-row-${ins.id}`}>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-num font-bold text-slate-800">{ins.mission_number}</span>
                <StatusBadge map={INSTALL_STATUS} value={ins.status} />
                {ins.urgency === "urgent" && <span className="bg-red-100 text-red-700 text-[11px] font-bold px-2 py-0.5 rounded-full">⚡ URGENT</span>}
              </div>
              <p className="text-sm font-semibold text-slate-700 mt-1">{ins.product_name}</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500 mt-1">
                <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {ins.zone} · {ins.address}</span>
                {ins.scheduled_date && <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {formatDate(ins.scheduled_date)}</span>}
                {ins.scheduled_time && <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {ins.scheduled_time}</span>}
              </div>
              {ins.professional_name && <p className="text-xs text-slate-600 mt-1">Technicien : <strong>{ins.professional_name}</strong></p>}
              {ins.client_amount > 0 && <p className="text-sm font-num text-[#C85A32] font-bold mt-1">{formatFCFA(ins.client_amount)}</p>}

              {step >= 0 && (
                <div className="flex gap-1 mt-3 overflow-x-auto no-scrollbar">
                  {INSTALL_STEPS.map((s, i) => (
                    <div key={s} className={`h-1.5 flex-1 min-w-[24px] rounded-full ${i <= step ? "bg-[#16A34A]" : "bg-slate-200"}`} title={INSTALL_STATUS[s]?.label} />
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
